import { Button, Space } from '@arco-design/web-react'
import React from 'react'
export const LoongInToolPanel = ({
  children,
  options,
  className,
  sizeClass = 'small',
  simple = false,
  float = 'right', //控制按钮的位置 left,right
}) => {
  options = options || {}
  const renderComponent = (key, i) => {
    if (options[key].render && typeof options[key].render === 'function') {
      return options[key].render(i)
    } else {
      return (
        <Button
          key={i}
          type={options[key].type || 'default'} //'default' | 'primary' | 'secondary' | 'dashed' | 'text' | 'outline';
          status={options[key].status} //'warning' | 'danger' | 'success' | 'default'
          size={options[key]?.size ?? sizeClass} //size?: 'mini' | 'small' | 'default' | 'large';
          icon={options[key].icon}
          disabled={options[key].disabled}
          loading={options[key].isLoading}
          onClick={() => {
            if (options[key].onClick) {
              options[key].onClick()
            }
          }}
        >
          {options[key].text}
        </Button>
      )
    }
  }
  const renderOptionButton = () => {
    const x = []
    let i = 0
    for (const key in options) {
      i++
      x.push(<React.Fragment key={i}>{renderComponent(key, i)}</React.Fragment>)
    }
    return x
  }
  const toolContent = (
    <Space wrap size={[8, 8]}>
      {renderOptionButton()}
      {children}
    </Space>
  )
  return (
    <>
      {simple && toolContent}
      {!simple && (
        <div className={className}>
          <div style={{ float }}>{toolContent}</div>
        </div>
      )}
    </>
  )
}
